define(function(require, exports, module) {
    const ReCaptcha = require('modules/google-recaptcha/recaptcha');
    const config = require('config');
    const i18n = require('i18n');

    ReCaptcha.prototype.render = function render({ onValidate, onError }) {
        this.api.render({
            operation: this.operation,
            casinoName: config.get('casinoName'),
            ssoPasDomain: config.get('ssoPasDomain'),
            defaultLocale: config.get('defaultLocale'),
            onValidate: ({ token, expirationTime }) => {
                onValidate && onValidate({ token, expirationTime });
            },
            onError: ({ errorCode, errorMessage } = {}) => {
                const translation = 'playtech.mobile.system.recaptcha.error.technicalError';
                onError && onError({
                    content: errorMessage,
                    translation,
                    isScriptLoadingError: errorCode === this.api.ERRORS.SCRIPT_LOADING_ERROR.errorCode, // special case
                    translated: i18n.tExt(translation, errorMessage)
                });
            }
        });
    };

    module.exports = ReCaptcha;
});
